export const SPONSORSHIP_TYPES = {
  SPONSORED_BY: "Sponsored by",
  IN_PARTNERSHIP_WITH: "In partnership with",
  PAYED_BY: "Payed by",
} as const;

export type SponsorshipType =
  (typeof SPONSORSHIP_TYPES)[keyof typeof SPONSORSHIP_TYPES];
